import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import {isOptionalString, isPlainObject, parseEachOrNull} from '@Components/ai-chat-window/lib/stream-component-prop-guards';
import type {ActionListProps, ActionListRow} from './action-list.types';
import {ActionList} from './action-list';

const parseRow = (value: Record<string, unknown>): ActionListRow | null => {
  if (typeof value.id !== 'string' || typeof value.label !== 'string' || typeof value.actionLabel !== 'string' || !isOptionalString(value.meta) || !isOptionalString(value.iconUrl)) {
    return null;
  }

  return {
    id: value.id,
    label: value.label,
    meta: value.meta,
    iconUrl: value.iconUrl,
    actionLabel: value.actionLabel,
    actionData: isPlainObject(value.actionData) ? value.actionData : undefined,
  };
};

const parseActionListProps = (props: Record<string, unknown>): ActionListProps | null => {
  if (typeof props.actionType !== 'string' || !Array.isArray(props.rows) || props.rows.length === 0) {
    return null;
  }

  const rows = parseEachOrNull(props.rows, parseRow);
  if (rows === null) {
    return null;
  }

  return {rows, actionType: props.actionType};
};

export const actionListRegistration = defineStreamComponentRegistration(StreamComponentType.ACTION_LIST, ActionList, parseActionListProps);
